import React from 'react';
import SobreProj from '../components/SobreProj';


const Sobre=() =>{
    return(
        
            <SobreProj/>
    );
}
export default Sobre;
